// extracted by mini-css-extract-plugin
module.exports = {"payment":"Payment_payment__3CUbb","inputs":"Payment_inputs__TU6si","btns":"Payment_btns__xDWX9"};